import React from 'react'

const SvgComponent = props => (
  <svg width={505} height={489} {...props}>
    <defs>
      <linearGradient
        x1="28.17%"
        y1="24.841%"
        x2="155.653%"
        y2="90.79%"
        id="hero__prefix__c"
      >
        <stop stopColor="#F57B94" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <path
        d="M187.475 343.133c-2.714 0-5.429-.695-7.855-2.098L13.753 245.469a3.801 3.801 0 0 1-1.934-3.333c0-1.39.721-2.637 1.934-3.333l103.876-59.855.804.468 172.918 99.642a3.801 3.801 0 0 1 1.934 3.333c0 1.39-.721 2.637-1.934 3.332l-96.02 55.324a15.794 15.794 0 0 1-7.856 2.086zm-69.858-160.468l-102.254 58.92a.616.616 0 0 0-.325.55c0 .133.036.396.325.552l165.866 95.567a12.559 12.559 0 0 0 12.492 0l96.02-55.324a.616.616 0 0 0 .325-.551.603.603 0 0 0-.325-.552l-172.124-99.162z"
        id="hero__prefix__b"
      />
      <filter
        x="-3.4%"
        y="-5.2%"
        width="106.8%"
        height="111.6%"
        filterUnits="objectBoundingBox"
        id="hero__prefix__a"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={3}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="hero__prefix__d">
        <stop stopColor="#FEECEF" offset="0%" />
        <stop stopColor="#FCD3DB" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="155.653%"
        y2="90.79%"
        id="hero__prefix__e"
      >
        <stop stopColor="#F57B94" offset="0%" />
        <stop stopColor="#E3486A" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="-12.039%"
        y1="1.214%"
        x2="270.409%"
        y2="172.34%"
        id="hero__prefix__f"
      >
        <stop stopColor="#F6B4C2" offset="0%" />
        <stop stopColor="#F6708E" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="0%"
        y1="37.947%"
        x2="116.628%"
        y2="60.888%"
        id="hero__prefix__g"
      >
        <stop stopColor="#FBDDE3" offset="0%" />
        <stop stopColor="#FF859D" offset="100%" />
      </linearGradient>
      <path id="hero__prefix__h" d="M.215.287h24.717v24.412H.215z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g opacity={0.5} transform="scale(1 -1) rotate(30 840.197 -179.92)">
        <path
          d="M.275 45.043l81.34-1.703a20 20 0 0 0 17.116-10.374l9.101-16.587A20 20 0 0 1 125.366 6h51.916"
          stroke="#E13F5E"
          strokeDasharray="4"
        />
        <circle
          stroke="#FFF2F2"
          strokeWidth={3}
          fill="#E13F5E"
          cx={183}
          cy={6}
          r={6}
        />
      </g>
      <g opacity={0.5} transform="rotate(-31 815.491 173.73)">
        <path
          d="M.7 51.014l137.236 3.866c5.52.155 10.122-4.194 10.277-9.715a10 10 0 0 0-.53-3.508l-3.755-11.014c-3.32-9.74 1.883-20.326 11.623-23.646A18.63 18.63 0 0 1 161.562 6h47.72"
          stroke="#E13F5E"
        />
        <circle
          stroke="#FFF2F2"
          strokeWidth={3}
          fill="#E13F5E"
          cx={215}
          cy={6}
          r={6}
        />
      </g>
      <g opacity={0.184} fillRule="nonzero" transform="translate(123 47.752)">
        <use
          fill="#000"
          filter="url(#hero__prefix__a)"
          xlinkHref="#hero__prefix__b"
        />
        <use fill="url(#hero__prefix__c)" xlinkHref="#hero__prefix__b" />
      </g>
      <path
        d="M3.303 139.449L26.413 2.62l-1.862-.779L27.338.247v.012c.54-.36 1.31-.336 2.15.144l184.677 106.415c1.513.875 2.666 3.117 2.402 4.687l-23.29 137.92c-.12.719-.48 1.198-.973 1.402l-2.727 1.57-.468-2.541.156.048L5.705 144.136c-1.525-.875-2.678-3.117-2.402-4.687z"
        fill="url(#hero__prefix__d)"
        transform="translate(237.11 47.752)"
      />
      <path
        d="M213.132 110.57l3.039-1.342c.336.779.504 1.594.396 2.277l-23.29 137.92c-.12.719-.48 1.198-.973 1.402l-2.727 1.57-.468-2.541.156.048-9.285-5.347 33.152-133.987z"
        fill="url(#hero__prefix__c)"
        transform="translate(237.11 47.752)"
      />
      <path
        d="M2.799 145.79l184.676 106.416c1.43.827 2.643.347 2.895-1.127l23.29-137.908c.265-1.57-.876-3.812-2.402-4.687L26.581 2.07c-1.429-.827-2.642-.348-2.894 1.127L.397 141.103c-.265 1.57.888 3.812 2.402 4.687z"
        fill="url(#hero__prefix__e)"
        transform="translate(237.11 47.752)"
      />
      <path
        d="M22.002.079l178.01 102.58-22.077 129.887L.045 130.038z"
        opacity={0.51}
        transform="translate(244.115 58.541)"
        fill="url(#hero__prefix__f)"
      />
      <g>
        <path
          d="M.817 65.837l10.077 5.25L111.96 12.851c1.694-.971 4.649-.851 6.594.276l174.3 100.433c1.669-.935 9.272-4.58 9.272-4.58l-3.687 9.591-.012-.012c-.157.432-.48.827-1.033 1.139l-106.434 61.33c-1.694.97-4.649.85-6.595-.276L5.994 77.98c-.805-.467-1.298-1.019-1.502-1.582l-.012.012L.817 65.837z"
          fill="url(#hero__prefix__c)"
          transform="translate(123 193.003)"
        />
        <path
          d="M2.378 67.491l182.803 105.337c2.006 1.15 5.033 1.282 6.763.275l109.088-62.852c1.73-.994 1.514-2.745-.48-3.896L117.749 1.02c-2.006-1.15-5.033-1.283-6.763-.276L1.898 63.595c-1.742.995-1.526 2.745.48 3.896z"
          fill="url(#hero__prefix__g)"
          transform="translate(123 193.003)"
        />
        <path
          d="M363.314 343.042v-2.002c0-.192-.12-.276-.252-.192l-7.075 4.076c-.144.084-.252.3-.252.492v2.001c0 .192.12.276.252.192l7.075-4.076c.144-.083.252-.311.252-.491zM352.744 349.132v-2.002c0-.192-.12-.276-.252-.192l-7.075 4.076c-.144.084-.252.3-.252.491v2.002c0 .192.12.276.252.192l7.075-4.076c.132-.084.252-.3.252-.491z"
          fill="#E13F5E"
        />
        <path
          d="M272.589 104.354l-151.91-87.535a3.249 3.249 0 0 0-3.267 0l-54.1 31.24c-.78.444-.78 1.57 0 2.014L215.15 137.56a3.249 3.249 0 0 0 3.267 0l54.172-31.193c.769-.443.769-1.558 0-2.013z"
          fill="url(#hero__prefix__d)"
          transform="translate(123 193.003)"
        />
        <path
          d="M395.589 299.37l-.54.312-151.37-87.223a3.249 3.249 0 0 0-3.267 0l-53.547 30.917-.54-.312a1.159 1.159 0 0 1 0-2.014l54.1-31.24a3.249 3.249 0 0 1 3.266 0l151.91 87.535c.757.467.757 1.582-.012 2.026z"
          fill="#FB8BA3"
        />
        <g fill="#F17993">
          <path d="M236.316 217.746l131.959 76.026 5.861-3.38-131.946-76.027zM221.939 226.03l123.766 71.315 5.862-3.381L227.8 222.649zM212.57 231.424l145.723 83.974 5.862-3.38-145.724-83.975zM203.2 236.83l145.724 83.963 5.862-3.38-145.724-83.963zM193.832 242.225l145.723 83.962 5.862-3.38-145.724-83.963zM376.25 298.364l5.862 3.38 5.874-3.38-5.874-3.381zM355.555 303.015l12.18 7.025 5.86-3.38-12.179-7.026z" />
        </g>
        <path
          d="M114.83 125.536l-40.96-23.604c-1.597-.923-1.597-2.422 0-3.345l28.011-16.135c1.598-.923 4.193-.923 5.802 0l40.96 23.604c1.597.923 1.597 2.421 0 3.344l-28.012 16.136c-1.61.923-4.204.923-5.801 0z"
          fill="url(#hero__prefix__d)"
          transform="translate(123 193.003)"
        />
        <path
          d="M271.63 300.425l-40.959-23.603c-1.597-.924-4.192-.924-5.802 0l-28.01 16.135c-.493.288-.817.623-1.01.983-.42-.803-.095-1.714 1.01-2.35l28.01-16.135c1.598-.923 4.192-.923 5.802 0l40.96 23.604c1.104.635 1.429 1.546 1.008 2.35-.192-.348-.516-.696-1.009-.984z"
          fill="#FF9EB3"
        />
      </g>
      <g>
        <g fill="#FFE6E6">
          <path d="M427.672 168.884l3.507 2.241.432-2.601-3.507-2.23zM424.8 186.482l3.508 2.23 2.487-15.213-3.508-2.242zM423.42 194.885l3.507 2.242.997-6.042-3.52-2.242zM421.99 203.6l3.507 2.242.997-6.042-3.519-2.242zM421.065 173.954l3.508 2.242.985-6.042-3.508-2.23zM419.167 185.51l3.52 2.23 1.453-8.859-3.52-2.241zM417.438 196.132l3.507 2.242 1.25-7.613-3.52-2.23zM420.56 212.327l3.52 2.23.985-6.03-3.507-2.241zM422.435 165.551l3.519 2.242.42-2.602-3.507-2.241z" />
        </g>
        <path
          fill="#FFF"
          opacity={0.9}
          d="M416.56 219.112l6.127 3.908.42-2.517-6.126-3.92z"
        />
      </g>
      <g fill="#FFCFCF">
        <path
          opacity={0.5}
          d="M309.923 13.079l-15.327-8.835V.887l15.327 8.823zM317.778 17.598l-5.513-3.177v-3.356l5.513 3.176zM323.868 21.11l-3.747-2.157v-3.357l3.747 2.158zM302.944 16.723l-8.348-4.807V8.559l8.348 4.807zM315.52 23.976l-10.234-5.898V14.72l10.234 5.898zM321.61 27.488l-3.748-2.17v-3.356l3.748 2.157zM327.412 30.82l-3.76-2.157v-3.357l3.76 2.158z"
        />
        <path d="M300.638 23.076l-6.042-3.488v-3.357l6.042 3.477zM305.046 25.606l-2.066-1.187v-3.356l2.066 1.186z" />
        <path
          opacity={0.5}
          d="M311.136 29.118l-3.748-2.158v-3.356l3.748 2.158zM316.89 40.111l-22.294-12.85v-3.357l22.294 12.85zM324.757 44.642l-5.525-3.176v-3.369l5.525 3.189zM300.638 38.42l-6.042-3.488v-3.356l6.042 3.476zM314.812 46.584l-11.832-6.82v-3.357l11.832 6.82zM320.901 50.097l-3.747-2.158v-3.356l3.747 2.157zM306.956 49.737l-12.36-7.132v-3.357l12.36 7.12z"
        />
        <path d="M318.235 56.235l-8.937-5.155v-3.357l8.937 5.155z" />
        <path
          opacity={0.5}
          d="M326.619 61.066l-6.042-3.489v-3.356l6.042 3.488zM298.764 52.686l-4.168-2.41V46.92l4.168 2.41zM306.632 57.218l-5.526-3.177v-3.369l5.526 3.189zM317.862 63.691l-8.888-5.13v-3.357l8.888 5.13zM307.388 65.321l-12.792-7.36v-3.369l12.792 7.373zM321.706 73.58l-11.975-6.904v-3.357l11.975 6.905z"
        />
        <path d="M327.796 77.093l-3.748-2.17v-3.356l3.748 2.158z" />
        <path
          opacity={0.5}
          d="M333.646 80.462l-3.748-2.17v-3.356l3.748 2.157zM302.26 70.045l-7.664-4.412v-3.369l7.664 4.424z"
        />
        <path d="M334.306 27.128l10.63 6.114v-3.356l-10.63-6.114z" />
        <path
          opacity={0.5}
          d="M336.576 36.107l8.36 4.82v-3.37l-8.36-4.806zM338.895 45.11l6.041 3.488V45.23l-6.041-3.477zM336.144 51.2l8.792 5.07v-3.356l-8.792-5.07zM338.895 60.454l6.041 3.489v-3.357l-6.041-3.488zM337.273 67.203l7.663 4.412v-3.357l-7.663-4.423zM340.756 76.878l4.18 2.41V75.93l-4.18-2.41zM336.84 82.296l8.096 4.663v-3.356l-8.095-4.664zM337.273 90.22l7.663 4.411v-3.356l-7.663-4.412zM307.857 73.27l-3.255-1.883v-3.356l3.255 1.882zM317.538 78.844l-7.339-4.22v-3.369l7.34 4.232zM369.356 47.184l-15.327-8.823v-3.369l15.327 8.835zM377.211 51.715l-5.525-3.177v-3.356l5.525 3.177z"
        />
        <path d="M383.301 55.228l-3.747-2.158V49.7l3.747 2.17z" />
        <path
          opacity={0.5}
          d="M362.377 50.84l-8.348-4.807v-3.369l8.348 4.82zM374.953 58.08l-10.234-5.885v-3.369l10.234 5.898z"
        />
        <path d="M381.043 61.593l-3.748-2.158V56.08l3.748 2.158z" />
        <path
          opacity={0.5}
          d="M386.832 64.938l-3.747-2.158V59.41l3.747 2.17zM360.07 57.182l-6.04-3.477V50.35l6.04 3.476zM364.467 59.723l-2.054-1.187V55.18l2.054 1.186zM370.569 63.235l-3.76-2.157v-3.369l3.76 2.17zM376.322 74.228l-22.293-12.85V58.02l22.293 12.85zM384.19 78.76l-5.525-3.19v-3.356l5.525 3.177zM360.07 72.526l-6.04-3.476v-3.357l6.04 3.476zM374.244 80.702l-11.83-6.821v-3.357l11.83 6.821zM380.334 84.214l-3.747-2.17v-3.356l3.747 2.158z"
        />
        <path d="M366.389 83.842l-12.36-7.12v-3.357l12.36 7.12z" />
        <path
          opacity={0.5}
          d="M377.668 90.34l-8.937-5.143V81.84l8.937 5.143zM386.052 95.17l-6.042-3.476v-3.356l6.042 3.476zM358.197 86.803l-4.168-2.41v-3.356l4.168 2.41zM366.065 91.335l-5.526-3.189V84.79l5.526 3.177z"
        />
        <path d="M377.295 97.796l-8.9-5.119v-3.356l8.9 5.119z" />
        <path
          opacity={0.5}
          d="M366.81 99.439l-12.78-7.373V88.71l12.78 7.373zM381.139 107.686l-11.987-6.905v-3.356l11.987 6.905zM387.229 111.199l-3.748-2.158v-3.357l3.748 2.158zM393.078 114.567l-3.747-2.158v-3.356l3.747 2.158zM361.692 104.162l-7.663-4.424v-3.356l7.663 4.411z"
        />
        <path d="M393.74 61.234l10.617 6.125v-3.356l-10.618-6.126z" />
        <path
          opacity={0.5}
          d="M396.01 70.224l8.347 4.807v-3.356l-8.348-4.807zM398.315 79.227l6.042 3.477v-3.357l-6.042-3.476zM395.577 85.317l8.78 5.059v-3.357l-8.78-5.059zM398.315 94.571l6.042 3.477v-3.357l-6.042-3.476zM396.694 101.309l7.663 4.411v-3.356l-7.663-4.412zM400.19 110.995l4.167 2.41v-3.37l-4.168-2.397zM396.274 116.413l8.083 4.663v-3.368l-8.083-4.651zM396.694 124.325l7.663 4.424v-3.357l-7.663-4.423z"
        />
        <path d="M367.29 107.386l-3.255-1.882v-3.356l3.255 1.87z" />
        <path
          opacity={0.5}
          d="M376.959 112.96l-7.327-4.23v-3.358l7.327 4.232zM309.923 82.176l-15.327-8.835v-3.356l15.327 8.835zM317.778 86.708l-5.513-3.177v-3.369l5.513 3.189zM323.868 90.22l-3.747-2.17v-3.356l3.747 2.157zM302.944 85.832l-8.348-4.819v-3.356l8.348 4.819zM315.52 93.073l-10.234-5.898v-3.357l10.234 5.898zM321.61 96.585l-3.748-2.157V91.07l3.748 2.158zM327.412 99.93l-3.76-2.17v-3.356l3.76 2.157zM300.638 92.174l-6.042-3.477V85.33l6.042 3.488zM305.046 94.715l-2.066-1.198V90.16l2.066 1.199zM311.136 98.228l-3.748-2.17v-3.357l3.748 2.158zM316.89 109.22l-22.294-12.85V93l22.294 12.851zM324.757 113.74l-5.525-3.177v-3.356l5.525 3.176zM300.638 107.518l-6.042-3.476v-3.369l6.042 3.489zM314.812 115.694l-11.832-6.821v-3.369l11.832 6.821zM320.901 119.194l-3.747-2.157v-3.357l3.747 2.158zM306.956 118.835l-12.36-7.121v-3.357l12.36 7.121zM318.235 125.332l-8.937-5.143v-3.368l8.937 5.155zM326.619 130.163l-6.042-3.476v-3.357l6.042 3.477zM298.764 121.796l-4.168-2.41v-3.356l4.168 2.397zM306.632 126.315l-5.526-3.177v-3.356l5.526 3.177zM317.862 132.789l-8.888-5.12v-3.356l8.888 5.119zM307.388 134.43l-12.792-7.372v-3.356l12.792 7.36zM321.706 142.678l-11.975-6.905v-3.356l11.975 6.905zM327.796 146.19l-3.748-2.157v-3.357l3.748 2.158zM333.646 149.56l-3.748-2.158v-3.357l3.748 2.158zM302.26 139.142l-7.664-4.411v-3.357l7.664 4.411zM334.306 96.226l10.63 6.126v-3.357l-10.63-6.126zM336.576 105.217l8.36 4.807v-3.357l-8.36-4.819zM338.895 114.22l6.041 3.476v-3.357l-6.041-3.488zM336.144 120.31l8.792 5.058v-3.357l-8.792-5.058zM338.895 129.564l6.041 3.476v-3.356l-6.041-3.477zM337.273 136.3l7.663 4.412v-3.356l-7.663-4.412zM340.756 145.987l4.18 2.398v-3.357l-4.18-2.41zM336.84 151.406l8.096 4.65V152.7l-8.095-4.663zM337.273 159.317l7.663 4.424v-3.369l-7.663-4.411zM307.857 142.367l-3.255-1.87v-3.357l3.255 1.87zM317.538 147.953l-7.339-4.232v-3.356l7.34 4.22zM323.604 173.763l-12.384-7.133v-3.357l12.384 7.133zM332.084 178.642l-4.877-2.805v-3.357l4.877 2.805zM369.356 116.293l-15.327-8.835v-3.356l15.327 8.823zM377.211 120.813l-5.525-3.177v-3.357l5.525 3.177zM383.301 124.325l-3.747-2.158v-3.356l3.747 2.158zM362.377 119.938l-8.348-4.807v-3.357l8.348 4.807zM374.953 127.19l-10.234-5.898v-3.356l10.234 5.898zM381.043 130.703l-3.748-2.17v-3.357l3.748 2.158zM386.832 134.035l-3.747-2.158v-3.356l3.747 2.158zM360.07 126.291l-6.04-3.488v-3.357l6.04 3.477zM364.467 128.82l-2.054-1.186v-3.357l2.054 1.187zM370.569 132.333l-3.76-2.158v-3.356l3.76 2.157zM376.322 143.326l-22.293-12.851v-3.357l22.293 12.851zM384.19 147.857l-5.525-3.177v-3.368l5.525 3.189zM360.07 141.635l-6.04-3.488v-3.357l6.04 3.489zM374.244 149.8l-11.83-6.822v-3.356l11.83 6.82zM380.334 153.312l-3.747-2.158v-3.357l3.747 2.158zM366.389 152.952l-12.36-7.133v-3.356l12.36 7.12zM377.668 159.45l-8.937-5.155v-3.357l8.937 5.155zM386.052 164.28l-6.042-3.488v-3.357l6.042 3.489zM358.197 155.9l-4.168-2.409v-3.356l4.168 2.41zM366.065 160.432l-5.526-3.176v-3.369l5.526 3.189zM377.295 166.906l-8.9-5.131v-3.357l8.9 5.131zM366.81 168.536l-12.78-7.36v-3.369l12.78 7.372zM381.139 176.796l-11.987-6.905v-3.357l11.987 6.905zM387.229 180.308l-3.748-2.17v-3.356l3.748 2.157zM393.078 183.677l-3.747-2.17v-3.357l3.747 2.158zM361.692 173.26l-7.663-4.412v-3.369l7.663 4.424zM393.74 130.343l10.617 6.126V133.1l-10.618-6.114zM396.01 139.322l8.347 4.819v-3.369l-8.348-4.807zM398.315 148.325l6.042 3.488v-3.368l-6.042-3.477zM395.577 154.414l8.78 5.071v-3.356l-8.78-5.071zM398.315 163.669l6.042 3.488v-3.356l-6.042-3.489zM396.694 170.418l7.663 4.412v-3.357l-7.663-4.423zM400.19 180.092l4.167 2.41v-3.357l-4.168-2.41zM396.274 185.51l8.083 4.664v-3.357l-8.083-4.663zM396.694 193.435l7.663 4.411v-3.356l-7.663-4.412zM367.29 176.484l-3.255-1.882v-3.357l3.255 1.882zM376.959 182.058l-7.327-4.22v-3.368l7.327 4.232zM383.037 207.868l-12.384-7.133v-3.356l12.384 7.132zM391.505 212.759l-4.877-2.817v-3.357l4.877 2.817z"
        />
      </g>
      <g opacity={0.331}>
        <path
          fill="url(#hero__prefix__c)"
          d="M0 90.807L73.786 135 74 57.71.085 16z"
          transform="translate(363 -10)"
        />
        <path
          fill="url(#hero__prefix__c)"
          opacity={0.58}
          d="M52 68.376L94.876 94 95 49.185 52.05 25z"
          transform="translate(363 -10)"
        />
        <g transform="translate(457 -10)">
          <mask id="hero__prefix__i" fill="#fff">
            <use xlinkHref="#hero__prefix__h" />
          </mask>
          <path mask="url(#hero__prefix__i)" d="M.215 24.7h24.717V.286H.215z" />
        </g>
      </g>
      <g>
        <g transform="translate(137 71)" fill="url(#hero__prefix__c)">
          <path opacity={0.513} d="M.22 107.105L34.313.607v126.17z" />
          <path d="M34.313.607v126.17l34.094-19.672z" />
        </g>
        <g transform="translate(86 128)" fill="url(#hero__prefix__c)">
          <path d="M35.955 99.117V.085l35.411 78.61z" />
          <path opacity={0.513} d="M35.955.085l-35.4 78.61 35.4 20.422z" />
        </g>
        <g transform="translate(433 272)" fill="url(#hero__prefix__c)">
          <path d="M35.955 99.117V.085l35.411 78.61z" />
          <path opacity={0.513} d="M35.955.085l-35.4 78.61 35.4 20.422z" />
        </g>
        <path
          d="M121.569 129.002v-13.24"
          stroke="#F8ADBB"
          strokeWidth={0.5}
          strokeLinecap="round"
        />
        <path
          d="M22.591 8.068c0 7.104-5.014 15.758-11.218 19.323C5.183 30.969.155 28.1.155 20.997S5.17 5.24 11.373 1.674c6.204-3.565 11.218-.698 11.218 6.394z"
          fill="url(#hero__prefix__d)"
          transform="translate(115.34 90.167)"
        />
        <text
          fill="#F67B94"
          fontFamily="Helvetica"
          fontSize={12}
          transform="translate(115.34 90.167)"
        >
          <tspan x={7.835} y={19.759}>
            {'A'}
          </tspan>
        </text>
        <g>
          <path
            d="M135.423 89.955l-.09-.065c.025.013.064.052.09.065z"
            fill="#1F909F"
          />
          <path
            d="M9.507 27.177c0-7.104 5.015-15.759 11.218-19.324 3.089-1.782 5.894-1.963 7.923-.813l-9.383-5.425v.012C17.223.4 14.38.542 11.239 2.365 5.049 5.942.021 14.596.021 21.687c0 3.5 1.215 5.955 3.192 7.143H3.2l.09.052s.014 0 .014.013l9.46 5.463c-2.016-1.162-3.257-3.642-3.257-7.181z"
            fill="url(#hero__prefix__c)"
            opacity={0.461}
            transform="translate(106 84)"
          />
        </g>
        <g>
          <path
            d="M468.569 273.002v-13.24"
            stroke="#F8ADBB"
            strokeWidth={0.5}
            strokeLinecap="round"
          />
          <path
            d="M22.591 8.068c0 7.104-5.014 15.758-11.218 19.323C5.183 30.969.155 28.1.155 20.997S5.17 5.24 11.373 1.674c6.204-3.565 11.218-.698 11.218 6.394z"
            fill="url(#hero__prefix__d)"
            transform="translate(462.34 234.167)"
          />
          <text
            fill="#F67B94"
            fontFamily="Helvetica"
            fontSize={12}
            transform="translate(462.34 234.167)"
          >
            <tspan x={7.835} y={19.759}>
              {'A'}
            </tspan>
          </text>
          <g>
            <path
              d="M482.423 233.955l-.09-.065c.025.013.064.052.09.065z"
              fill="#1F909F"
            />
            <path
              d="M9.507 27.177c0-7.104 5.015-15.759 11.218-19.324 3.089-1.782 5.894-1.963 7.923-.813l-9.383-5.425v.012C17.223.4 14.38.542 11.239 2.365 5.049 5.942.021 14.596.021 21.687c0 3.5 1.215 5.955 3.192 7.143H3.2l.09.052s.014 0 .014.013l9.46 5.463c-2.016-1.162-3.257-3.642-3.257-7.181z"
              fill="url(#hero__prefix__c)"
              opacity={0.461}
              transform="translate(453 228)"
            />
          </g>
        </g>
        <g>
          <path
            d="M172.22 73.524v-13.24"
            stroke="#F8ADBB"
            strokeWidth={0.5}
            strokeLinecap="round"
          />
          <path
            d="M22.535 8.602c0 7.105-5.015 15.759-11.218 19.324-6.191 3.578-11.218.71-11.218-6.394S5.113 5.774 11.317 2.21c6.203-3.578 11.218-.71 11.218 6.393z"
            fill="url(#hero__prefix__d)"
            transform="translate(166.047 34.167)"
          />
          <text
            fill="#F67B94"
            fontFamily="Helvetica"
            fontSize={12}
            transform="translate(166.047 34.167)"
          >
            <tspan x={8.254} y={20.009}>
              {'B'}
            </tspan>
          </text>
          <g>
            <path
              d="M186.074 34.477l-.09-.065a.393.393 0 0 0 .09.065z"
              fill="#1F909F"
            />
            <path
              d="M10.158 26.712c0-7.104 5.015-15.759 11.218-19.324 3.09-1.782 5.894-1.963 7.923-.813L19.916 1.15v.013c-2.042-1.228-4.885-1.086-8.039.736C5.687 5.477.66 14.13.66 21.222c0 3.5 1.215 5.955 3.192 7.143h-.013l.09.052s.014 0 .014.013l9.46 5.463c-2.003-1.175-3.244-3.655-3.244-7.181z"
              fill="url(#hero__prefix__c)"
              opacity={0.461}
              transform="translate(156 29)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SvgComponent
